/* Trends Essentials landing: reveals, AJAX cart drawer, honey quantity picker, ski mask color picker. */
(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const money = (cents) => '$' + (Number(cents) / 100).toFixed(2);

  async function api(path, body) {
    const opts = body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
      : { headers: { Accept: 'application/json' } };
    const res = await fetch(root + path, opts);
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    return data;
  }

  /* ---------- Scroll reveals ---------- */
  const revealEls = $$('[data-reveal]');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- Page switch: react on tap while Shopify serves the next page ---------- */
  const navLinks = $$('.tl-nav__links a');
  const homeLink = navLinks.find((a) => a.getAttribute('aria-current'));
  function markCurrent(link) {
    navLinks.forEach((a) => a.removeAttribute('aria-current'));
    if (link) link.setAttribute('aria-current', 'page');
  }
  navLinks.forEach((link) => link.addEventListener('click', (e) => {
    if (link.getAttribute('aria-current') || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    markCurrent(link);
    document.documentElement.classList.add('tl-leaving');
  }));
  // Back/forward can restore this page from cache mid-fade; put it back as it was
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    document.documentElement.classList.remove('tl-leaving');
    markCurrent(homeLink);
  });

  /* ---------- Cart drawer ---------- */
  const drawer = $('[data-cart-drawer]');
  const itemsEl = drawer && $('[data-cart-items]', drawer);
  const drawerError = drawer && $('[data-cart-error]', drawer);

  function prettyTitle(item) {
    const color = (item.product_title.match(/\[([^\]]+)\]/) || [])[1];
    if (color) return { name: 'Hyperwarm Hood Ski Mask', meta: color.trim().replace(/^\w/, (c) => c.toUpperCase()) };
    const plan = item.selling_plan_allocation ? ' · ' + item.selling_plan_allocation.selling_plan.name : '';
    if (/^honey/i.test(item.product_title)) return { name: 'Royal Honey Sachets', meta: (item.variant_title || '') + plan };
    return { name: item.product_title.replace(/&amp;/g, '&'), meta: (item.variant_title || '') + plan }; // cart.js escapes & in titles
  }

  function setCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      const changed = el.textContent !== String(count);
      el.textContent = count;
      el.hidden = count === 0;
      if (changed && count > 0) {
        el.classList.remove('is-bump');
        void el.offsetWidth;
        el.classList.add('is-bump');
      }
    });
  }

  function lineEl(item, index) {
    const { name, meta } = prettyTitle(item);
    const li = document.createElement('li');
    li.className = 'tl-line';

    if (item.image) {
      const img = document.createElement('img');
      img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
      img.alt = '';
      img.width = 72;
      img.height = 72;
      img.onerror = () => { img.onerror = null; img.src = item.image; };
      li.append(img);
    } else {
      li.append(document.createElement('span'));
    }

    const body = document.createElement('div');
    const n = document.createElement('div');
    n.className = 'tl-line__name';
    n.textContent = name;
    const m = document.createElement('div');
    m.className = 'tl-line__meta';
    m.textContent = meta;
    const qty = document.createElement('div');
    qty.className = 'tl-line__qty';
    const minus = document.createElement('button');
    minus.type = 'button';
    minus.textContent = '−';
    minus.setAttribute('aria-label', 'Remove one ' + name);
    const q = document.createElement('span');
    q.textContent = item.quantity;
    const plus = document.createElement('button');
    plus.type = 'button';
    plus.textContent = '+';
    plus.setAttribute('aria-label', 'Add one more ' + name);
    minus.addEventListener('click', () => changeLine(index + 1, item.quantity - 1));
    plus.addEventListener('click', () => changeLine(index + 1, item.quantity + 1));
    qty.append(minus, q, plus);
    body.append(n, m, qty);

    const price = document.createElement('div');
    price.className = 'tl-line__price';
    price.textContent = money(item.final_line_price);

    li.append(body, price);
    return li;
  }

  function renderCart(cart) {
    setCount(cart.item_count);
    if (!drawer) return;
    itemsEl.replaceChildren(...cart.items.map(lineEl));
    $('[data-cart-empty]', drawer).hidden = cart.item_count > 0;
    $('[data-cart-footer]', drawer).hidden = cart.item_count === 0;
    $('[data-cart-subtotal]', drawer).textContent = money(cart.total_price);
    const savings = $('[data-cart-savings]', drawer);
    if (savings) {
      savings.hidden = !cart.total_discount;
      $('[data-cart-saved]', savings).textContent = money(cart.total_discount);
    }
    const upsell = $('[data-upsell]', drawer);
    if (upsell) {
      const pid = Number(upsell.dataset.productId);
      upsell.hidden = cart.items.some((i) => i.product_id === pid);
    }
  }

  async function refreshCart() {
    try {
      renderCart(await api('cart.js'));
    } catch (err) {
      if (drawerError) drawerError.textContent = err.message;
    }
  }

  async function changeLine(line, quantity) {
    if (drawerError) drawerError.textContent = '';
    itemsEl.setAttribute('aria-busy', 'true');
    try {
      renderCart(await api('cart/change.js', { line, quantity: Math.max(0, quantity) }));
    } catch (err) {
      drawerError.textContent = err.message;
    } finally {
      itemsEl.removeAttribute('aria-busy');
    }
  }

  function openDrawer() {
    if (!drawer || drawer.open) return;
    if (typeof drawer.showModal === 'function') drawer.showModal();
    else drawer.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    if (typeof drawer.close === 'function') drawer.close();
    else drawer.removeAttribute('open');
  }

  if (drawer) {
    drawer.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer || e.target.closest('[data-cart-close]')) closeDrawer();
    });
    $$('[data-cart-open]').forEach((el) => el.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer();
      refreshCart();
    }));
  }

  /* ---------- Add to cart (every form[data-add-form]) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-add-form]');
    if (!form || !drawer) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const errEl = form.querySelector('[data-form-error]') || drawerError;
    if (errEl) errEl.textContent = '';
    let items;
    if (form.dataset.items) {
      items = JSON.parse(form.dataset.items);
    } else {
      const fd = new FormData(form);
      const picked = form.querySelector('input[name="quantity"]:checked');
      const id = Number((picked && picked.dataset.id) || fd.get('id'));
      const plan = Number(fd.get('selling_plan'));
      items = id ? [{ id, quantity: Number(fd.get('quantity')) || 1, ...(plan && { selling_plan: plan }) }] : [];
    }
    if (!items.length) return;
    btn && btn.setAttribute('aria-busy', 'true');
    try {
      await api('cart/add.js', { items });
      renderCart(await api('cart.js'));
      openDrawer();
    } catch (err) {
      if (errEl) errEl.textContent = err.message;
    } finally {
      btn && btn.removeAttribute('aria-busy');
    }
  });

  setCount(Number(($('[data-cart-count]') || {}).textContent) || 0);

  /* ---------- Honey: live total on the button ---------- */
  $$('[data-honey-form]').forEach((form) => {
    const total = $('[data-honey-total]', form);
    // data-total carries the tiered one-time price, data-sub-total the subscription price (both rendered by Liquid)
    const sync = () => {
      const sub = !!(form.querySelector('input[name="selling_plan"]:checked') || {}).value;
      form.classList.toggle('is-sub', sub);
      $$('input[name="quantity"][data-total]', form).forEach((r) => {
        if (!r.dataset.subTotal) r.disabled = sub;
      });
      let picked = form.querySelector('input[name="quantity"]:checked');
      if (picked && picked.disabled) {
        picked = form.querySelector('input[name="quantity"]:not(:disabled)');
        if (picked) picked.checked = true;
      }
      if (picked && total) total.textContent = money(sub ? picked.dataset.subTotal : picked.dataset.total);
    };
    form.addEventListener('change', (e) => {
      if (e.target.name === 'quantity' || e.target.name === 'selling_plan') sync();
    });
  });

  /* ---------- Honey: build your own bundle ---------- */
  // Adds plain box lines; the "3+ boxes" automatic discount in admin prices them. Math mirrors checkout (rounded per box).
  $$('[data-builder]').forEach((form) => {
    const min = Number(form.dataset.min) || 3;
    const max = Number(form.dataset.max) || 5;
    const pct = Number(form.dataset.pct) || 0;
    const picks = $$('[data-pick]', form);
    const qty = new Map(picks.map((p) => [p, 0]));
    const el = (k) => $('[data-b-' + k + ']', form);
    const btn = $('[type="submit"]', form);

    function render() {
      let n = 0; let full = 0;
      qty.forEach((q, p) => { n += q; full += q * Number(p.dataset.price); });
      const on = n >= min;
      let total = 0;
      qty.forEach((q, p) => {
        const price = Number(p.dataset.price);
        total += (price - (on ? Math.floor(price * pct / 100) : 0)) * q;
        p.classList.toggle('is-picked', q > 0);
        $('output', p).textContent = q;
        $('[data-step="-1"]', p).disabled = q === 0;
        $('[data-step="1"]', p).disabled = q >= max;
      });
      el('total').textContent = money(total);
      el('btn').textContent = money(total);
      el('full').textContent = on && total < full ? money(full) : '';
      el('save').textContent = on && total < full ? 'Save ' + money(full - total) : '';
      el('meter').style.transform = 'scaleX(' + Math.min(1, n / min) + ')';
      const left = min - n;
      const oneEach = n === picks.length && [...qty.values()].every((q) => q === 1);
      el('msg').textContent = oneEach && form.dataset.oneEach ? form.dataset.oneEach
        : left > 0 ? 'Add ' + left + ' more box' + (left === 1 ? '' : 'es') + ' to save ' + pct + '%.'
        : n + ' boxes, ' + n * 12 + ' sachets. You\'re saving ' + pct + '%.';
      form.dataset.items = JSON.stringify([...qty].filter(([, q]) => q > 0).map(([p, q]) => ({ id: Number(p.dataset.id), quantity: q })));
      btn.disabled = !on;
    }

    form.addEventListener('click', (e) => {
      const step = e.target.closest('[data-step]');
      if (!step) return;
      const p = step.closest('[data-pick]');
      qty.set(p, Math.max(0, Math.min(max, qty.get(p) + Number(step.dataset.step))));
      render();
    });
    render();
  });

  /* ---------- Ski masks: color picker ---------- */
  const picker = $('[data-mask-picker]');
  const dataEl = $('[data-mask-data]');
  if (picker && dataEl) {
    let masks = [];
    try { masks = JSON.parse(dataEl.textContent); } catch (_) { masks = []; }

    const mainImg = $('.sm-gallery__img', picker);
    const thumbs = $('[data-thumbs]', picker);
    const colorEl = $('[data-mask-color]', picker);
    const priceEl = $('[data-mask-price]', picker);
    const stockEl = $('[data-mask-stock]', picker);
    const idEl = $('[data-mask-id]', picker);
    const addBtn = $('[data-mask-add]', picker);
    const LOW_STOCK = 5;
    const qtyRadios = $$('input[name="quantity"]', picker);
    let current = masks[Number(($('input[name="tl-color"]:checked', picker) || {}).value) || 0];

    // Same math as the automatic discounts: percent off each mask, rounded per mask
    function tierTotal(price, n, pct) {
      return (price - Math.floor(price * pct / 100)) * n;
    }

    function renderTiers() {
      if (!current) return;
      qtyRadios.forEach((r) => {
        const n = Number(r.value);
        const pct = Number(r.dataset.pct) || 0;
        const box = r.nextElementSibling;
        $('[data-tier-price]', box).textContent = money(tierTotal(current.price, n, pct));
        $('[data-tier-full]', box).textContent = money(current.price * n);
      });
      const picked = qtyRadios.find((r) => r.checked);
      if (!current.available) { addBtn.textContent = 'Sold out'; return; }
      const n = picked ? Number(picked.value) : 1;
      addBtn.textContent = n > 1
        ? 'Add ' + n + ' to cart \u00b7 ' + money(tierTotal(current.price, n, Number(picked.dataset.pct) || 0))
        : 'Add to cart';
    }

    function showImage(image, alt) {
      if (!mainImg || !image) return;
      mainImg.classList.add('is-swapping');
      const pre = new Image();
      pre.srcset = image.srcset;
      pre.sizes = mainImg.sizes;
      pre.src = image.src;
      const swap = () => {
        mainImg.srcset = image.srcset;
        mainImg.src = image.src;
        if (alt) mainImg.alt = alt;
        requestAnimationFrame(() => mainImg.classList.remove('is-swapping'));
      };
      if (pre.complete) setTimeout(swap, 120);
      else { pre.onload = swap; pre.onerror = swap; }
    }

    function buildThumbs(mask) {
      if (!thumbs) return;
      const btns = mask.images.map((img, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'sm-thumb';
        b.setAttribute('aria-label', 'Show photo ' + (i + 1));
        if (i === 0) b.setAttribute('aria-current', 'true');
        const t = document.createElement('img');
        t.src = img.thumb;
        t.alt = '';
        t.width = 80;
        t.height = 80;
        b.append(t);
        b.addEventListener('click', () => {
          $$('.sm-thumb', thumbs).forEach((x) => x.removeAttribute('aria-current'));
          b.setAttribute('aria-current', 'true');
          showImage(img);
        });
        return b;
      });
      thumbs.replaceChildren(...btns);
      thumbs.hidden = btns.length < 2;
    }

    function select(i) {
      const mask = masks[i];
      if (!mask) return;
      showImage(mask.images[0], mask.color + ' hood ski mask');
      buildThumbs(mask);
      colorEl.textContent = mask.color;
      priceEl.textContent = money(mask.price);
      idEl.value = mask.variant;
      stockEl.textContent = mask.available && mask.inv > 0 && mask.inv <= LOW_STOCK
        ? 'Only ' + mask.inv + ' left in ' + mask.color
        : '';
      addBtn.disabled = !mask.available;
      current = mask;
      renderTiers();
    }

    // Wire up the server-rendered thumbs for the starting color
    const startRadio = $('input[name="tl-color"]:checked', picker);
    if (startRadio && masks[startRadio.value]) buildThumbs(masks[startRadio.value]);

    // Product URLs redirect here with ?color=<product handle>; preselect that colorway
    const wanted = new URLSearchParams(location.search).get('color');
    const wantedIndex = wanted ? masks.findIndex((m) => m.handle === wanted) : -1;
    if (wantedIndex > -1) {
      const radio = $('input[name="tl-color"][value="' + wantedIndex + '"]', picker);
      if (radio) radio.checked = true;
      select(wantedIndex);
    }

    picker.addEventListener('change', (e) => {
      if (e.target.name === 'tl-color') select(Number(e.target.value));
      if (e.target.name === 'quantity') renderTiers();
    });

    $$('[data-select-mask]').forEach((btn) => btn.addEventListener('click', () => {
      const i = Number(btn.dataset.selectMask);
      const radio = $('input[name="tl-color"][value="' + i + '"]', picker);
      if (radio) radio.checked = true;
      select(i);
      picker.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }));
  }
})();
